/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{position:absolute;width:150px;height:70px;pointer-events:none;transition:opacity 0s}.ag-tooltip-hiding[_nghost-%COMP%]{opacity:0}.custom-tooltip[_ngcontent-%COMP%]{position:relative;display:inline-block;background-color:#000;border-radius:6px}.tooltiptext[_ngcontent-%COMP%]{color:#fff;text-align:left;padding:5px 0;position:absolute;z-index:10}"];
export { styles as styles };
